// extracted by mini-css-extract-plugin
export default {"navbar":"mfr-I1NsjCOX"};